import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "prose prose-slate dark:prose-invert max-w-none",
    innerHTML: _ctx.sanitizedHtml
  }, null, 8, _hoisted_1))
}